import styled from '@emotion/styled';
import React from 'react';
import { device } from '../../styles/devices';
import { typography } from '../../styles/typography';

interface IProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

const Host = styled.div`
  margin-bottom: 30px;
  width: 100%;

  line-height: ${`calc(27 / ${typography.sizes.bodySize})`};

  @media ${device.mobile} {
    width: calc(50% - 25px);
    margin-right: 25px;
  }

  @media ${device.tablet} {
    width: auto;
    margin-right: 35px;
  }

  @media ${device.pageLimit} {
    margin-right: 70px;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const Title = styled.div`
  font-weight: 500;
`;

const List = styled.div``;

export const FooterGroup = ({ title, children }: IProps) => {
  return (
    <Host>
      <Title>{title}</Title>
      <List>{children}</List>
    </Host>
  );
};
